<template>
    <section
        v-if="showBtn"
        class="button-wrapper"
    >
        <div
            class="download-top-button-wrapper"
            :style="{'margin-bottom': appDetail.recommend_download ? '5.6vw' : ''}"
        >
            <div
                v-if="appDetail.recommend_download" class="tieba-download-btn"
                @click="goTiebaDownload"
            >
                <div>去贴吧下载</div>
                <img :src="fuliIcon" class="fuliIcon">
            </div>
            <detail-download
                id="topBtn"
                :is-ios="!!isIOS"
                :official-joined="appDetail.officialJoined"
                :packages="appDetail.package_list"
                :app-detail="appDetail"
                :icon="appDetail.icon"
                :package-name="appDetail.package_name"
                :inter-btn-text="appDetail.book_button_text"
                :bussiness-info="appDetail.bussinessInfo"
                :download-url="appDetail.download_url"
                :app-id="appDetail.appId"
                :tieba-info="tiebaInfo"
                :style="{width: appDetail.recommend_download ? `${552 / 12.42}vw` : `${1140 / 12.42}vw`}"
                pos="top"
            />
        </div>
    </section>
</template>

<script>
import DetailDownload from './app-detail-download.vue';
import {throttle} from 'throttle-debounce';
import {isIOS, copy} from '@/utils/browser';
import {on, isInContainer} from '@/utils/dom';
import fuliIcon from 'public/assets/imgs/fuli-icon.png';
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import {generateToken} from '@/utils/tiebaUtility';
export default {
    components: {
        DetailDownload,
    },
    props: {
        appDetail: {
            type: Object,
            default: () => {},
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isIOS: isIOS(),
            fuliIcon: fuliIcon,
        };
    },
    computed: {
        showBtn() {
            const thePackage = this.appDetail.package_list && this.appDetail.package_list[0] || {};
            const {action} = thePackage;
            const {DOWNLOAD} = this.$root.DOWNLOAD_ACTIONS;
            return action === DOWNLOAD
                && ((this.isMobile && this.appDetail.package_list && this.appDetail.package_list.length)
                    || (this.appDetail.bussinessInfo && this.appDetail.bussinessInfo.appRcv));
        },
    },
    created() {
        on(window, 'scroll', throttle(200, this.handleScroll));
    },
    mounted() {
        this.$nextTick(() => {
            this.handleScroll();
        });
    },
    methods: {
        handleScroll() {
            const dom = document.getElementById('topBtn');
            this.$root.isShowTopBtn = isInContainer(dom, 80) && this.showBtn;
        },
        getToken() {
            const config = {
                page: 'tbwebview',
                param: {
                    obj_source: 'wise',
                    locate: 'outer_game_recommend',
                    url: encodeURIComponent(this.appDetail.recommend_download?.act_url || ''),
                },
            };
            return generateToken(config);
        },
        goTiebaDownload() {
            // 贴吧推荐下载
            this.$root.sendLog('click', 'recommendBtn_click');
            setTimeout(() => {
                this.$root.isShowRcDownloadDrawer = true;
            }, 500);
            const token = this.getToken();
            copy(token);
            this.$root.report(token).then(() => {
                TiebaNewWakeUp.init({
                    page: 'tbwebview',
                    param: {
                        obj_source: 'wise',
                        locate: 'outer_game_recommend',
                        url: encodeURIComponent(this.appDetail.recommend_download?.act_url || ''),
                    },
                    androidShoubaiGoCenterPage: false,
                    androidDownUrl: this.appDetail.recommend_download.download_url || '',
                    ios: 'new',
                    waitTime: 3000,
                    iosDownUrl: isIOS ? this.appDetail.join_community_info.download_url_for_smart : '',
                });
            });
        },
    },
};

</script>

<style lang="scss" scoped>
.button-wrapper {
    .download-top-button-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tieba-download-btn {
            position: relative;
            width: 552px;
            height: 126px;
            border-radius: 66px;
            background-color: rgba(78,110,242,.1);
            background-image: linear-gradient(to bottom right,#e8f7ff,#edf0ff);
            color: #3388FF;
            text-align: center;
            line-height: 126px;
            font-size: 48px;
            .fuliIcon {
                widows: 96px;
                height: 53px;
                position: absolute;
                top: -27px;
                right: 0;
            }
        }
    }
}
</style>